import {
    useMemo,
} from 'react'

import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import Typeahead from 'app/shared-components/Typeahead'
import aPricingRateCardRequests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import useGetAPricingRateCard from 'app/requests/APricingRateCard/hooks/useGetAPricingRateCard'
import {
    APricingRateCardFilterRequestResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'
import useGetAccount from 'app/requests/Account/hooks/useGetAccount'
import {
    useGetCompany,
} from 'app/Apps/ContactManagement/Companies'

type Props = {
    name?: string,
    value?: number,
    onChange: (id: number) => void,
    title?: string,
    disabled?: boolean,
    className?: string,
    required?: boolean,
    placeholder?: string,
    noneOption?: boolean,
    includeFilters?: Record<string, any>,
}

const conversionFn = (items: APricingRateCardFilterRequestResponse[]) => {
    return items.map((item) => {
        return {
            ...item,
            label: `${item.number}/${item.accountName} (${item.validFrom})`,
            value: item.id,
        }
    })
}

export default function ARateCardSelector({
    name = '',
    value,
    onChange,
    title = 'Rate Card',
    className = '',
    disabled = false,
    required = false,
    placeholder,
    noneOption = true,
    includeFilters,
}: Readonly<Props>) {
    const selectorParams = useMemo(() => {
        return {
            ...aPricingRateCardRequests.filterRequest(),
            includeFilters,
            convertion: conversionFn,
        }
    }, [includeFilters])

    const loadOptions = useDelayedLoadOptions(selectorParams)

    const {
        data: rateCard,
    } = useGetAPricingRateCard(value)

    const {
        data: account,
    } = useGetAccount(rateCard?.account?.id)

    const {
        data: company,
    } = useGetCompany(account?.company?.id)

    const rateCardData = useMemo(() => {
        return {
            ...rateCard,
            label: rateCard ? `${rateCard.number}/${company?.companyName} (${rateCard.validFrom})` : '',
        }
    }, [
        rateCard,
        company,
    ])

    return (
        <Typeahead
            name={name}
            title={title}
            className={className}
            onChange={onChange}
            loadOptions={loadOptions}
            labelData={rateCardData}
            labelField="label"
            value={value}
            disabled={disabled}
            isRequired={required}
            placeholder={placeholder}
            noneOption={noneOption}
        />
    )
}
